export default __webpack_public_path__ + "static/media/iphoneDesign.e1e9a764.webp";